import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";

interface DelivaryWeightConfirmationDialogProps {
  open: boolean;
  onConfirm: (e:any) => void;
  onCancel: () => void;
}

const DelivaryWeightConfirmationDialog: React.FC<DelivaryWeightConfirmationDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
    const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{t(LOCALIZATION.Confirmation)}</DialogTitle>
      <DialogContent>
        <Typography>
          {t(LOCALIZATION.Delivary_Message)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>
          {t(LOCALIZATION.No)}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t(LOCALIZATION.Yes)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DelivaryWeightConfirmationDialog;